import { ReviewOrderAccountBillToCardContainer } from "../../NewOrders/Review/reviewOrder.styles.ts";
import {
	AccountBillToCard,
	AccountBillToCardDetails,
	AccountBillToCardDetailsContainer,
	AccountBillToCardHeader
} from "../../NewOrders/ViewPriceEstimates/viewPriceEstimates.styles.ts";
import { NewOrderAccountNumber } from "../../NewOrders/constants.ts";
import StyledSummaryCardLogo from "styles/StyledComponents/StyledSummaryCardLogo.tsx";
import { brandCheck } from "utils/order.ts";
import BillToBox from "components/Common/BillToShipToBox/BillToBox/BillToBox.tsx";
import { OrderType } from "types/declarations/enums.ts";
import { models } from "types/api/viewModels.ts";
import { getConfigurationAccountInfo } from "components/NewOrders/utils/NewOrderUtils.tsx";
import { RootState } from "stores/application.store.tsx";
import { useSelector } from "react-redux";
import { BrandLogo } from "components/Common/AccountAndBillTo/accountAndBillTo.styles.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

interface Props {
	newOrderConfig?: models["PendingOrderConfigurationViewModel"];
	addOnConfig?: models["PendingOrderConfigurationViewModel"];
}

const AccountAndBillTo = ({ newOrderConfig, addOnConfig }: Props) => {
	const { isNewOrderReviewPage, isNewOrderConfirmationPage, isAddOnPage } = useUserLocation();
	const productLineAccountInfo = useSelector((state: RootState) => state.newOrder.productLineAccounts);
	const config = newOrderConfig ?? addOnConfig;
	const configurationBillToInfo = getConfigurationAccountInfo(config, productLineAccountInfo)?.billTos?.find(
		(billTo) => billTo.billToId === config?.billToId
	);
	const showProductLine = isNewOrderReviewPage || isNewOrderConfirmationPage || isAddOnPage;
	return (
		<ReviewOrderAccountBillToCardContainer isAddOn={!!addOnConfig}>
			<AccountBillToCard>
				<AccountBillToCardHeader>{NewOrderAccountNumber}</AccountBillToCardHeader>
				<AccountBillToCardDetailsContainer>
					<AccountBillToCardDetails>
						<div data-testid="new-order-review-order-list-account-id">{config?.accountNumber}</div>
						<div data-testid="new-order-review-order-list-account-name">{config?.accountName}</div>
					</AccountBillToCardDetails>
					<BrandLogo>
						<StyledSummaryCardLogo
							data-testid="new-order-review-order-list-brand-logo"
							parentBrand={config?.globals?.brand?.code}
							src={
								brandCheck(config?.globals?.brand?.code)
									? `/assets/manufacture_logos/${config?.globals?.brand?.code}.png`
									: "/assets/tandem_logos/cwg_logo.png"
							}
							alt={
								config?.globals?.brand?.code && brandCheck(config?.globals?.brand?.code)
									? (config?.globals?.brand?.description ?? "")
									: "CabinetworksGroup Logo"
							}
						/>
						{showProductLine && <div>{config?.globals?.productLine?.description}</div>}
					</BrandLogo>
				</AccountBillToCardDetailsContainer>
			</AccountBillToCard>
			<BillToBox
				billTo={configurationBillToInfo}
				orderType={OrderType.UNKNOWN}
				hasBorder
				containsSubtotal={false}
				dataTestIdPrefix="new-order-review-order-list"
			/>
		</ReviewOrderAccountBillToCardContainer>
	);
};

export default AccountAndBillTo;
